import type { Size } from './order.model';

type Dimensions = Pick<Size, 'width' | 'height'>;

// Orientation-independent identifier of a print size: 10×15 and 15×10 are the same size.
export type SizeKey = `${number}x${number}`;

export const getSizeKey = ({ width, height }: Dimensions): SizeKey =>
  `${Math.min(width, height)}x${Math.max(width, height)}`;

export const sizeArea = ({ width, height }: Dimensions): number => width * height;

export const compareSizesByArea = (a: Dimensions, b: Dimensions): number =>
  sizeArea(a) - sizeArea(b) || a.width - b.width;

// Same format as the photo prices page, e.g. "10 × 15 cm".
export const formatSize = ({ width, height }: Dimensions): string => `${width} × ${height} cm`;
